import L from 'leaflet'
import { motion } from 'framer-motion'
import { faArrowUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dictionary, groupBy, uniqueId } from 'lodash'
import { Fragment, useEffect, useState, lazy, Suspense } from 'react'

//STYLE
import { Book } from './style'

//APP
import { useAccess } from '../../../../../../../../context/useAccess'
import { ResultadoAnaliseOS__Item } from '../../../../../../../../services/AgriculturaPrecisao/bookResumido/GET'
import { ItensMapaFertilidadeTypes } from '../../../../../../../../services/Laboratorio/osResultado'
import {
  obterObservacao,
  verificarVisibilidadeElemento,
} from '../../../../../../../../Components/ordemLaboratorio/mapaFertilidade/DrawerPrint/meta/config_book'
import {
  useGetElementosFertilidade,
  useGetParametrosFertilidadeRef,
} from '../../../../../../../../services/novoConfigBook/get'
import {
  calcularAreaTalhoes,
  filtrarTalhoes,
  gerarKrigagem,
  mesclarListagem,
  obterValorDefinicao,
} from './meta'
import {
  dadosElemento,
  listaFertilidadesComCalcario,
  nomeProfundidade,
  obterInfoDoElemento,
  replceCalcarioDescription,
} from './meta/page_elemento'

//COMPONENT
import Carregando from '../../../../../../../../Components/CustomUi/loading'
import ProgressLoading from '../../../../../../../../Components/CustomUi/progressLoading'
import { Aviso } from './components/aviso'
import { Render } from '../../../../../../../../Components/CustomUi/render'
import { CapaBookFertilidade } from './components/capa'
import { CapaBookResumo } from './components/capaResumo'
import secureLocalStorage from 'react-secure-storage';

//LAZY COMPONENTS
const Resumo = lazy(() =>
  import('./components/resumo').then((module) => ({ default: module.Resumo }))
)
const Sumario = lazy(() =>
  import('./components/sumario').then((module) => ({ default: module.Sumario }))
)
const Talhoes = lazy(() =>
  import('./components/talhoes').then((module) => ({ default: module.Talhoes }))
)
const PontosColetados = lazy(() =>
  import('./components/pontos').then((module) => ({ default: module.PontosColetados }))
)
const PageAnaliseElemento = lazy(() =>
  import('./components/pageElemento').then((module) => ({ default: module.PageAnaliseElemento }))
)
const SubCapaBookFertilidade = lazy(() =>
  import('./components/subCapa').then((module) => ({ default: module.SubCapaBookFertilidade }))
)

//TYPES
type typeKrigagemProcessada = {
  bounds: any
  circle: number[]
  dataProfundidade: ItensMapaFertilidadeTypes[]
  krigagem: {
    url: string
    colors: unknown[]
    descriptionElemento: any
    ordem: number
    bounds: any
    valor_interpretado: any
  }[]
}
type typeTalhoesSelecionados = {
  cod_talhao: number
  nome_talhao: string
  cod_pedido: number
  talhao_area: number
  coordenadas: { latitude: number; longitude: number }[]
}

//PROPS
interface Props {
  open: boolean
  exibir_terreno: boolean
  lista_dados_os: ResultadoAnaliseOS__Item[]
  talhoes_selecionados: typeTalhoesSelecionados[]
  nome_propriedade_selecionada: string
  tipo_representacao: 'Interpretado' | 'Distribuído'
  nome_calcario_propriedade: string
  cods_elementos_selecionados: number[]
  profundidades_filtrar_selecionadas: string[]
  qualidade_definicao_krigagem:
  | 'Automática'
  | 'Definição baixa'
  | 'Definição padrão'
  | 'Definição melhorada'
  area_talhoes: number
  talhoes_filtrados: number[]
  nome_safra_selecionada: string
  exibir_lista_talhoes: boolean
  resumirBook: boolean
}

export const BookFertilidadeResumidoSeparado: React.FC<Props> = ({
  exibir_terreno,
  lista_dados_os,
  talhoes_selecionados,
  nome_propriedade_selecionada,
  tipo_representacao,
  nome_calcario_propriedade,
  cods_elementos_selecionados,
  profundidades_filtrar_selecionadas,
  qualidade_definicao_krigagem,
  area_talhoes,
  talhoes_filtrados,
  nome_safra_selecionada,
  exibir_lista_talhoes,
  resumirBook,
}) => {
  //CONST
  const { consultoria, nameCliente } = useAccess()
  const nome_cliente_localStorage = localStorage.getItem('nome-cliente')
  const local = secureLocalStorage.getItem('Itens')
  const logo = local?.[0]?.acessoConta?.contas?.[0]?.logo
  const logo_localStorage = localStorage.getItem('logo')

  //STATES
  const [loading_book, setLoading_book] = useState<boolean>(true)
  const [qualidade_definicao_book, setQualidade_definicao_book] = useState<number>(null)
  const [polygon, setPolygon] = useState<L.LatLngExpression[]>([])
  const [krigagem_processada, setKrigagem_processada] = useState<typeKrigagemProcessada[]>([])
  const [fator_2_krigagem_processada, setFator_2_krigagem_processada] = useState<
    typeKrigagemProcessada[]
  >([])
  const [krigagem_processada_por_talhao, setKrigagem_processada_por_talhao] = useState<
    typeKrigagemProcessada[][]
  >([])
  const [profundidades_agrupadas, setProfundidades_agrupadas] = useState<{
    [key: string]: ItensMapaFertilidadeTypes[]
  }>()
  const [exibir_paginas_analises, setExibir_paginas_analises] = useState<boolean>(false)
  const [render_paginas, setRender_paginas] = useState<boolean>(false)
  const [progress, setProgress] = useState<number>(0)
  const [talhoes_com_pedidos, setTalhoes_com_pedidos] = useState<typeTalhoesSelecionados[]>([])
  const [OS_agrupados_por_cod_pedido, setOS_agrupados_por_cod_pedido] =
    useState<Dictionary<ResultadoAnaliseOS__Item[]>>(null)
  const [lista_pedidos_OS, setLista_pedidos_OS] = useState<
    { cod_pedido: string; dados_pedido: ResultadoAnaliseOS__Item[] }[]
  >([])
  const [pedido_talhao_atual, setPedido_talhao_atual] = useState<number>(0)
  const [talhoes_agrupados_por_cod_pedido, setTalhoes_agrupados_por_cod_pedido] =
    useState<Dictionary<typeTalhoesSelecionados[]>>(null)
  const [iniciar_processamento, setIniciar_processamento] = useState<boolean>(false)
  const [primeiro_processamento_concluido, setPrimeiro_processamento_concluido] =
    useState<boolean>(false)
  const [loading_revisando, setLoading_revisando] = useState<boolean>(true)

  //API
  const { data_paramentros } = useGetParametrosFertilidadeRef()
  const { data_elementos, isFetched_elementos } = useGetElementosFertilidade()

  useEffect(() => {
    let qualidade_definicao = obterValorDefinicao(qualidade_definicao_krigagem, area_talhoes)
    setQualidade_definicao_book(qualidade_definicao)
  }, [])

  useEffect(() => {
    if (open) {
      let filtrar_talhoes =
        talhoes_filtrados.length === 0
          ? talhoes_selecionados
          : talhoes_selecionados.filter((item) => talhoes_filtrados.includes(item.cod_pedido))

      //@ts-ignore
      let list_cods_pedido = new Set((filtrar_talhoes ?? []).map((i) => i.cod_pedido).flat())

      let apenas_elementos_selecionados = lista_dados_os.filter((item) =>
        cods_elementos_selecionados.includes(item.cod_elemento)
      )
      let apenas_pedidos_dos_talhoes = apenas_elementos_selecionados.filter((item) =>
        list_cods_pedido.has(item.cod_pedido)
      )

      let agrupar_por_pedido = groupBy(apenas_pedidos_dos_talhoes, 'cod_pedido')
      setOS_agrupados_por_cod_pedido(agrupar_por_pedido)

      let listar_por_pedido = Object.entries(agrupar_por_pedido).map(([cod, dados]) => {
        return { cod_pedido: cod, dados_pedido: dados }
      })
      setLista_pedidos_OS(listar_por_pedido)

      let agrupar_talhoes_por_pedido = groupBy(filtrar_talhoes, 'cod_pedido')
      setTalhoes_agrupados_por_cod_pedido(agrupar_talhoes_por_pedido)

      let montar_lista_talhoes = listar_por_pedido.map((_, index) => {
        return agrupar_talhoes_por_pedido[listar_por_pedido[index].cod_pedido][0]
      })

      setTalhoes_com_pedidos(montar_lista_talhoes)

      setIniciar_processamento(true)
    }
  }, [data_elementos, isFetched_elementos, qualidade_definicao_book])

  function processarKrigagem() {
    let index_atual = pedido_talhao_atual

    if (isFetched_elementos && qualidade_definicao_book !== null) {
      gerarKrigagem(
        OS_agrupados_por_cod_pedido[lista_pedidos_OS[index_atual].cod_pedido],
        tipo_representacao,
        data_elementos?.itens?.[0]?.mapa_fertilidade?.configuracoes ?? [],
        () => { },
        qualidade_definicao_book,
        setPolygon,
        talhoes_agrupados_por_cod_pedido[lista_pedidos_OS[index_atual].cod_pedido],
        setKrigagem_processada,
        setProfundidades_agrupadas,
        profundidades_filtrar_selecionadas,
        resumirBook
      )

      setTimeout(() => {
        if (pedido_talhao_atual + 1 < talhoes_com_pedidos.length) {
          setPedido_talhao_atual((pedido_talhao_atual) => pedido_talhao_atual + 1)
        }
      }, 500)
    }
  }
  function segundoFatorProcessarKrigagem(
    os_pedidos_faltando: { cod_pedido: string; dados_pedido: ResultadoAnaliseOS__Item[] }[]
  ) {
    if (isFetched_elementos && qualidade_definicao_book !== null) {
      gerarKrigagem(
        OS_agrupados_por_cod_pedido[os_pedidos_faltando[0].cod_pedido],
        tipo_representacao,
        data_elementos?.itens?.[0]?.mapa_fertilidade?.configuracoes ?? [],
        () => { },
        qualidade_definicao_book,
        setPolygon,
        talhoes_agrupados_por_cod_pedido[os_pedidos_faltando[0].cod_pedido],
        setFator_2_krigagem_processada,
        setProfundidades_agrupadas,
        profundidades_filtrar_selecionadas,
        resumirBook
      )
    }
  }

  useEffect(() => {
    setKrigagem_processada_por_talhao((krigagem_processada_por_talhao) => [
      ...krigagem_processada_por_talhao,
      fator_2_krigagem_processada,
    ])
  }, [fator_2_krigagem_processada])

  useEffect(() => {
    if (primeiro_processamento_concluido) {
      revisarKrigagem()
    }
  }, [krigagem_processada_por_talhao])

  useEffect(() => {
    if (iniciar_processamento && !primeiro_processamento_concluido) {
      processarKrigagem()
    }
  }, [iniciar_processamento, krigagem_processada_por_talhao])

  useEffect(() => {
    if (talhoes_com_pedidos.length > 0) {
      let filtrar_talhoes =
        talhoes_filtrados.length === 0
          ? talhoes_com_pedidos
          : talhoes_com_pedidos.filter((item) => talhoes_filtrados.includes(item.cod_pedido))
      if (
        krigagem_processada.length > 0 &&
        krigagem_processada_por_talhao.length < filtrar_talhoes.length
      ) {
        setKrigagem_processada_por_talhao((krigagem_processada_por_talhao) => [
          ...krigagem_processada_por_talhao,
          krigagem_processada,
        ])
      }
    }
  }, [krigagem_processada, talhoes_com_pedidos])

  useEffect(() => {
    if (talhoes_com_pedidos.length > 0) {
      let filtrar_talhoes =
        talhoes_filtrados.length === 0
          ? talhoes_com_pedidos
          : talhoes_com_pedidos.filter((item) => talhoes_filtrados.includes(item.cod_pedido))
      let tempo_delay = filtrar_talhoes.length * 700 + 1700
      if (filtrar_talhoes.length === krigagem_processada_por_talhao.length) {
        setTimeout(() => {
          setRender_paginas(true)
        }, tempo_delay)
      }
    }
  }, [krigagem_processada_por_talhao, talhoes_com_pedidos])

  useEffect(() => {
    if (talhoes_com_pedidos.length > 0) {
      let filtrar_talhoes =
        talhoes_filtrados.length === 0
          ? talhoes_com_pedidos
          : talhoes_com_pedidos.filter((item) => talhoes_filtrados.includes(item.cod_pedido))
      if (filtrar_talhoes.length === krigagem_processada_por_talhao.length) {
        setTimeout(() => {
          setPrimeiro_processamento_concluido(true)
          setLoading_book(false)
        }, 700)
      }
    }
  }, [krigagem_processada_por_talhao, talhoes_com_pedidos])

  useEffect(() => {
    if (!loading_book) {
      setTimeout(() => {
        /**espera 1s para rendereizar as paginas melhorar a performance */
        setExibir_paginas_analises(true)
      }, 700)
    }
  }, [loading_book])

  useEffect(() => {
    if (talhoes_com_pedidos.length > 0) {
      let filtrar_talhoes =
        talhoes_filtrados.length === 0
          ? talhoes_com_pedidos
          : talhoes_com_pedidos.filter((item) => talhoes_filtrados.includes(item.cod_pedido))
      let qtd_processada = krigagem_processada_por_talhao.length
      let qtd_total = filtrar_talhoes.length
      let concluido = ((qtd_processada / qtd_total) * 100 - 1)?.toFixed()

      setProgress(Number(concluido))
    }
  }, [krigagem_processada_por_talhao, talhoes_com_pedidos])

  useEffect(() => {
    if (render_paginas && !loading_book) {
      setTimeout(() => {
        revisarKrigagem()
      }, 500)
    }
  }, [loading_book, render_paginas])

  useEffect(() => {
    if (resumirBook) {
      setQualidade_definicao_book(5.1111)
    }
  }, [resumirBook])

  function revisarKrigagem() {
    //@ts-ignore
    let cods_pedidos_atuais = krigagem_processada_por_talhao.flat().map((i) => i.cod_pedido)
    let pedidos_faltando = lista_pedidos_OS.filter(
      (i) => !cods_pedidos_atuais.includes(Number(i.cod_pedido))
    )

    if (pedidos_faltando.length > 0) {
      setLoading_revisando(true)
      segundoFatorProcessarKrigagem(pedidos_faltando)
    } else if (pedidos_faltando.length === 0) {
      setLoading_revisando(false)
    }
  }

  return (
    <Book id={'book_fertilidade_resumido'}>
      <Render condition={!render_paginas}>
        <div className='Book__loading' style={{ zIndex: 2 }}>
          <ProgressLoading
            animation
            justifyContent='center'
            legenda={
              progress === 99
                ? resumirBook
                  ? 'Preparando resumos...'
                  : 'Preparando mapas...'
                : 'Gerando book de fertilidade agrupado...'
            }
            height={650}
            progress={progress === -1 ? 0 : progress}
            ocultar_tempo_restante
          />
        </div>
      </Render>

      <Render condition={loading_revisando}>
        <div className='Book__loading' style={{ zIndex: 1 }}>
          <Carregando
            legenda={resumirBook ? 'Finalizando resumos...' : 'Finalizando mapas...'}
            animation
            height={650}
            justifyContent='center'
            style={{ opacity: render_paginas ? 1 : 0 }}
          />
        </div>
      </Render>

      <Render condition={!loading_book}>
        {/* <Animation type='fadeIn' delay={0.2}> */}
        {resumirBook ? (
          <CapaBookResumo
            responsavel={'Ronaldo Araújo Marques'}
            formacao={'Engenheiro Agrônomo'}
            dados_consultoria={consultoria}
          />
        ) : (
          <CapaBookFertilidade
            responsavel={'Ronaldo Araújo Marques'}
            formacao={'Engenheiro Agrônomo'}
            dados_consultoria={consultoria}
          />
        )}
        {/* </Animation> */}

        <Render condition={resumirBook === false}>
          <Suspense fallback={<>carregando sumário...</>}>
            <Sumario
              krigagem_processada={krigagem_processada}
              tipo_representacao={tipo_representacao}
            />
          </Suspense>

          <Aviso
            mensagem={data_elementos?.itens?.[0]?.mapa_fertilidade?.texto_introducao}
            logo={logo}
          />
        </Render>

        <Render condition={exibir_lista_talhoes}>
          <Suspense fallback={<>carregando lista de talhões...</>}>
            <Talhoes
              page_number={4}
              talhoes_selecionados={talhoes_com_pedidos}
              area_talhoes={calcularAreaTalhoes(talhoes_com_pedidos, talhoes_filtrados)}
            />
          </Suspense>
        </Render>

        {/* {mesclarListagem([], [], []).map((item) => { */}
        {mesclarListagem(
          krigagem_processada_por_talhao ?? [],
          krigagem_processada,
          talhoes_filtrados
        ).map((item) => {
          let {
            dataProfundidade,
            is_indicadores,
            is_prescricoes,
            circle,
            pagina,
            pagina_elementos,
            nome_profundidade_ref,
            nome_profundidade_pura,
          } = item

          let nome_profundidade = dataProfundidade?.[0]?.profundidade

          const main_bounds = L.polygon(polygon, {})

          let cores_invertidas = new Set([
            7, 18, 25, 26, 28, 30, 31, 32, 41, 42, 43, 44, 45, 46, 49, 50,
          ])

          return (
            <Fragment key={`fragment_${pagina}`}>
              {resumirBook === false && (
                <>
                  <Suspense fallback={<>carregando subcapa...</>}>
                    <SubCapaBookFertilidade
                      logo={logo}
                      nome_profundidade={nome_profundidade}
                      isIndicadores={is_indicadores}
                      isPrescricoes={is_prescricoes}
                      page_number={pagina}
                      isGranulometria={nome_profundidade == '00-50'}
                      key={`capa_${pagina}`}
                    />
                  </Suspense>

                  <Render
                    condition={!is_indicadores && !is_prescricoes}
                    key={`render_pontos_coletados_${pagina}`}
                  >
                    <PontosColetados
                      key={`pontos_coletados_${pagina}`}
                      exibir_terreno={exibir_terreno}
                      page_number={pagina}
                      nome_profundidade={nome_profundidade}
                      nome_cliente={nameCliente}
                      nome_propriedade={nome_propriedade_selecionada}
                      talhoes_selecionados={filtrarTalhoes(talhoes_com_pedidos, talhoes_filtrados)}
                      total_pontos_coletados={(circle ?? []).length}
                      circle={circle}
                      dataProfundidade={dataProfundidade}
                      polygon={polygon}
                    />
                  </Render>

                  <Render condition={exibir_paginas_analises}>
                    {(pagina_elementos ?? []).map(
                      (
                        {
                          descriptionElemento,
                          lista_urls,
                          colors,
                          ordem,
                          valor_interpretado,
                          pagina_elemento,
                        },
                        index
                      ) => {
                        let fertilidade_concatenada = listaFertilidadesComCalcario(
                          profundidades_agrupadas[nome_profundidade_pura]
                        )
                        let agrupar_elementos = groupBy(
                          fertilidade_concatenada,
                          'elemento_descricao'
                        )
                        let info_do_elemento = obterInfoDoElemento(
                          agrupar_elementos,
                          descriptionElemento
                        )

                        const obs_do_elemento: string = obterObservacao({
                          config_elementos:
                            data_elementos?.itens?.[0]?.mapa_fertilidade?.configuracoes,
                          cod_elemento: Number(info_do_elemento?.cod_elemento),
                          tipo_secao_ou_profundidade: nome_profundidade_pura,
                          tipo_mapa: tipo_representacao === 'Interpretado',
                          nome_elemento: descriptionElemento,
                        })

                        const isVisivelNoBook: boolean = verificarVisibilidadeElemento({
                          config_elementos:
                            data_elementos?.itens?.[0]?.mapa_fertilidade?.configuracoes,
                          cod_elemento: Number(info_do_elemento?.cod_elemento),
                          tipo_secao_ou_profundidade: nome_profundidade_pura,
                          tipo_mapa: tipo_representacao === 'Interpretado',
                          nome_elemento: descriptionElemento,
                          dados_prescricao: descriptionElemento.startsWith('Calcário')
                            ? (pagina_elementos ?? []).filter((i) =>
                              i.descriptionElemento?.startsWith('Calcário')
                            )
                            : undefined,
                        })

                        let split_calcario = descriptionElemento.split(' ')

                        let dados_elemento = dadosElemento({
                          lista_dados_os: lista_dados_os,
                          cod_elemento: info_do_elemento?.cod_elemento,
                          profundidade: nome_profundidade_pura,
                          cods_elementos_selecionados: cods_elementos_selecionados,
                          talhoes_filtrados: talhoes_filtrados,
                          talhoes_selecionados: talhoes_com_pedidos,
                          is_indicadores: is_indicadores,
                          is_prescricoes: is_prescricoes,
                          profundidade_calcario: split_calcario?.[split_calcario.length - 1],
                        })

                        if (isVisivelNoBook) {
                          return (
                            <Suspense
                              fallback={<>carregando mapas...</>}
                              key={`page__${pagina_elemento}__${ordem}__${index}`}
                            >
                              <PageAnaliseElemento
                                //CONFIGURAÇÕES DA PÁGINA -------------->
                                key={`${uniqueId()}__${pagina_elemento}__${ordem}__${index}`}
                                exibir_terreno={exibir_terreno}
                                page_number={pagina_elemento} //----> PRECISA CONCERTAR (14-04 | 09:53)
                                logo={logo_localStorage ?? logo}
                                //INFORMAÇÕES DO ELEMENTO -------------->
                                isPrescricoes={is_prescricoes}
                                isIndicadores={is_indicadores}
                                //TITULO DA PAGINA -------------->
                                nome_elemento={replceCalcarioDescription(descriptionElemento)}
                                nome_profundidade={nomeProfundidade(nome_profundidade_ref)}
                                nome_profundidade_pura={nomeProfundidade(nome_profundidade_pura)}
                                tipo_representacao={tipo_representacao}
                                //MAPA DE KRIGAGEM -------------->
                                colors={colors as string[]}
                                main_bounds={main_bounds}
                                lista_urls={lista_urls}
                                talhoes_selecionados={filtrarTalhoes(
                                  talhoes_com_pedidos,
                                  talhoes_filtrados
                                )}
                                //INFORMAÇÕES DO CLIENTE -------------->
                                nome_cliente={
                                  nameCliente !== ''
                                    ? nameCliente ?? nome_cliente_localStorage
                                    : nome_cliente_localStorage
                                }
                                nome_propriedade={nome_propriedade_selecionada}
                                //TABELA DETALHES -------------->
                                nameSafra={nome_safra_selecionada}
                                nome_calcario_propriedade={nome_calcario_propriedade}
                                //TABELA VALORES
                                unidade={
                                  (data_paramentros?.itens ?? []).find(
                                    (item) => item.cod === info_do_elemento?.cod_elemento
                                  )?.unidade
                                }
                                interpretado_minimo={Number(valor_interpretado?.minimo)}
                                interpretado_media={Number(valor_interpretado?.media)}
                                interpretado_maximo={Number(valor_interpretado?.maximo)}
                                isCorInvertida={cores_invertidas.has(
                                  info_do_elemento?.cod_elemento
                                )}
                                isInterpretado={tipo_representacao === 'Interpretado'}
                                cod_elemento={info_do_elemento?.cod_elemento}
                                nota_minima={dados_elemento?.minimo ?? null}
                                nota_media={dados_elemento?.media ?? null}
                                nota_maxima={dados_elemento?.maximo ?? null}
                                // nota_minima={info_do_elemento?.minimo}
                                // nota_media={info_do_elemento?.media}
                                // nota_maxima={info_do_elemento?.maximo}
                                area_talhoes={calcularAreaTalhoes(
                                  talhoes_com_pedidos,
                                  talhoes_filtrados
                                )}
                                obs_do_elemento={obs_do_elemento}
                              />
                            </Suspense>
                          )
                        }
                      }
                    )}
                  </Render>
                </>
              )}

              <Render condition={!is_indicadores && !is_prescricoes}>
                <Suspense fallback={<>carregando resumo...</>}>
                  <Resumo
                    page_number={
                      (pagina_elementos?.[pagina_elementos.length - 1]?.pagina_elemento ?? 0) + 1
                    }
                    nome_profundidade={nomeProfundidade(nome_profundidade_ref)}
                    lista_elementos={pagina_elementos}
                    lista_parametros={data_paramentros?.itens ?? []}
                    profundidades_agrupadas={profundidades_agrupadas}
                    nome_profundidade_pura={nome_profundidade_pura}
                    cores_invertidas={cores_invertidas}
                    isInterpretado={tipo_representacao === 'Interpretado'}
                    area_talhoes={area_talhoes}
                    cods_elementos_selecionados={cods_elementos_selecionados}
                    lista_dados_os={lista_dados_os}
                    talhoes_filtrados={talhoes_filtrados}
                    talhoes_selecionados={talhoes_com_pedidos}
                  />
                </Suspense>
              </Render>
            </Fragment>
          )
        })}

        <motion.a
          className='Book__back_to_sumario'
          whileTap={{ scale: 0.93 }}
          href='#sumario'
          id='voltar_para_sumario'
        >
          <FontAwesomeIcon icon={faArrowUp} />
        </motion.a>
      </Render>
    </Book>
  )
}